// constants/theme.js

export const THEME_CLASSES = {
    LIGHT: "theme-light",
    DARK: "theme-dark",
};

export const COLORS = {
    BLUE: "#0EA5E9",
    GREEN: "#10B981",
    PURPLE: "#8B5CF6",
    YELLOW: "#FBBF24",
    ORANGE: "#F97316",
    RED: "#EF4444",
    CYAN: "#06B6D4",
    PINK: "#EC4899",
    SLATE: "#64748B",
};

export const NODE_ACCENTS = {
    INPUT: COLORS.BLUE,
    OUTPUT: COLORS.RED,
    LLM: COLORS.PURPLE,
    TEXT: COLORS.GREEN,
    HTTP: COLORS.CYAN,
    DECISION: COLORS.PINK,
    MATH: COLORS.YELLOW,
    DELAY: COLORS.ORANGE,
    COLLECTOR: COLORS.SLATE,
};
